<template>
  <div>
    <b-form-input 
      autocomplete="off"
      v-model="filter[cellKey]"
    />
  </div>
</template>

<script>
export default {
  props: ['filter', 'cellKey']
}
</script>
